import styled from 'styled-components'
import { Spinner } from './Spinner/Spinner'

const LoadingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    bottom: 0;
    background: var(--overlay-background, rgba(255, 255, 255, 0.7));
    border-radius: 10px;
`

export const InnerLoading = () => {
    return (
        <LoadingContainer>
            <Spinner />
        </LoadingContainer>
    )
}
